import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { isValidated, validate } from '../../redux/actions/forgotPassword';

const resetTokenValidationWrapper = (WrappedComponent) => {
  class ResetTokenValidation extends Component {
    constructor(props) {
      super(props);

      this.state = {
        tokenValidated: false,
        redirect: false,
      };
    }

    componentDidMount() {
      // Validate the user before rendering the route
      this.requireValidation();
    }

    checkValidation = () => {
      const { forgotPassword } = this.props;
      if (!forgotPassword.isValidated) {
        return this.setState({ redirect: '/forgot-password'});
      }
      this.setState({
        tokenValidated: true,
      });
    };

    requireValidation = async () => {
      if (!isValidated(this.props)) {
        await this.props.doValidate(this.props);
        this.checkValidation();
      }
      return this.setState({ tokenValidated: true });
    };

    render() {
      if (this.state.redirect) {
        return <Redirect to={this.state.redirect} />;
      }
      return this.state.tokenValidated && <WrappedComponent {...this.props} />;
    }
  }

  return connect(
    state => ({
      routing: state.routing,
      forgotPassword: state.forgotPassword,
      user: state.forgotPassword.user,
      submitSuccess: state.forgotPassword.passwordSubmitSuccess
    }),
    dispatch => ({
      doValidate: (location) => dispatch(validate(location)),
    })
  )(ResetTokenValidation);
};

export default resetTokenValidationWrapper;
